/* eslint-disable no-undef */
import React, { useEffect, useRef } from "react";
import "./home.css";
import profileImage from "../website pic/Anmol 4.jpg";

const Home = ({ onContactClick, onProjectClick }) => {
  const titleRef = useRef(null);

  useEffect(() => {
    const title = titleRef.current;
    if (title) {
      title.classList.remove("animate-on-load");
      void title.offsetWidth; // force reflow
      title.classList.add("animate-on-load");
    }
  }, []);

  return (
    <section className="hero anime-hero">
      <section className="hero-content">
        {/* LEFT SIDE */}
        <div className="hero-left">
          <p className="hero-tagline">Toronto-based · Open to developer roles</p>

          <h1 className="hero-title animate-on-load" ref={titleRef}>
            <span className="highlight">
              <span className="bubble-word">Hi,</span>{" "}
              <span className="bubble-word">I'm</span>{" "}
              <span className="bubble-word">Anmol</span>{" "}
              <span className="bubble-word">Dhunna</span>
            </span>
          </h1>

          <p className="hero-name-jp">Front-End / Full-Stack Developer</p>

          <p className="hero-subtitle">
            I build accessible React interfaces and reliable Node.js applications,
            combining software engineering with four years of customer-facing
            technical support to create products people can actually understand.
          </p>

          <div className="hero-pills">
            <span className="pill">React &amp; TypeScript</span>
            <span className="pill">UI / UX Design</span>
            <span className="pill">Node.js &amp; SQL</span>
          </div>

          <div className="hero-cta">
           <button
              className="btn-ghost"
              type="button"
              onClick={onProjectClick}
            >
              View Projects
            </button>
            
            <button
              className="btn-primary"
              type="button"
              onClick={onContactClick}
            >
              Contact Me
            </button>
            <a className="btn-ghost" href="/PublicResume.pdf" target="_blank" rel="noreferrer">
              View Résumé
            </a>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="hero-right">
          <div className="image-orbit">
            <div className="orbit-ring orbit-ring-1" />
            <div className="orbit-ring orbit-ring-2" />
            <div className="orbit-ring orbit-ring-3" />

            <div className="image-frame anime-frame">
              <img
                src={profileImage}
                alt="Anmol Dhunna"
                className="profile-img"
                width="640"
                height="853"
                decoding="async"
              />
              <div className="corner-badge">player</div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Home;
